import { Routes } from '@angular/router';
import { AuthGuard } from '@frontend-library/src/lib/auth/auth.guard';
import { AdminLayoutComponent } from '@frontend-library/src/lib/layouts/admin-layout.component';
import { LoginComponent } from '@frontend-library/src/lib/auth/login/login.component';

export const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: 'users',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'users',
        loadChildren: './user/user.module#UserModule'
      },
      {
        path: 'partners',
        loadChildren: './partner/partner.module#PartnerModule'
      },
      {
        path: 'post',
        loadChildren: './post/post.module#PostModule'
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  }
];
